// services/reportingService.ts
import { auth } from '../firebase/config';
import { Run, UserProfile } from '../types';

export interface FetchOptions {
  startDate: string;            // YYYY-MM-DD
  endDate: string;              // YYYY-MM-DD
  tenantIds: string[];          // for PLATFORM_ADMIN / PARTNER_ADMIN filtering
  userProfile: UserProfile;
}

export interface ReportingData {
  runs: Run[];
  userDirectory?: Record<string, { email?: string; displayName?: string }>;
}
const API_BASE_URL = String(import.meta.env.VITE_API_BASE_URL || '').replace(/\/+$/, '');

if (!API_BASE_URL) {
  throw new Error('Missing VITE_API_BASE_URL. It must point to runmodule-api.');
}

export const reportingService = {
  async fetchReportingData(options: FetchOptions): Promise<ReportingData> {
    const user = auth.currentUser;
    if (!user) throw new Error('not_authenticated');

    const token = await user.getIdToken(true);

    const resp = await fetch(`${API_BASE_URL}/reportingData`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        startDate: options.startDate,
        endDate: options.endDate,
        tenantIds: options.tenantIds || [],
      }),
    });

    const data = await resp.json().catch(() => ({}));

    if (!resp.ok) {
  console.error("REPORTING ERROR BODY:", data);
  throw new Error(data?.error || data?.message || `reporting_http_${resp.status}`);
}

    return {
      runs: Array.isArray(data?.runs) ? data.runs : [],
      userDirectory: data?.userDirectory || {},
    };
  },
};